import {
  ArrowCounterClockwise,
  ArrowsClockwise,
  Atom,
  Baby,
  Bank,
  Bone,
  Brain,
  Briefcase,
  Bug,
  Buildings,
  Certificate,
  ChartBar,
  ChartDonut,
  ChartLine,
  ChartLineUp,
  ChatCircleDots,
  CheckCircle,
  Clock,
  Cloud,
  CloudArrowUp,
  Code,
  CoinVertical,
  CompassTool,
  Cpu,
  Cube,
  Database,
  DeviceMobile,
  Envelope,
  Eye,
  Factory,
  FilmStrip,
  Gear,
  GitBranch,
  Globe,
  GlobeHemisphereEast,
  GraduationCap,
  Handshake,
  Headset,
  Heart,
  HeartHalf,
  Lightbulb,
  Lightning,
  Lock,
  LockKey,
  Laptop,
  MagnifyingGlass,
  Medal,
  MegaphoneSimple,
  Monitor,
  Network,
  Package,
  PaintBrush,
  PaperPlaneTilt,
  Path,
  Phone,
  Receipt,
  Robot,
  Rocket,
  Scales,
  HardDrives,
  ShieldCheck,
  ShieldStar,
  ShoppingBag,
  Stethoscope,
  Star,
  Target,
  TrendUp,
  Trophy,
  Truck,
  UserCheck,
  UserCircle,
  Users,
  UsersFour,
  UsersThree,
  VectorThree,
  Warning,
  Wrench,
  XCircle,
  FacebookLogo,
  GoogleLogo,
  LinkedinLogo,
} from "@phosphor-icons/react";

/** Only icons used across the site — avoids importing the full Phosphor library (~1MB). */
const ICON_MAP = {
  ArrowCounterClockwise,
  ArrowsClockwise,
  Atom,
  Baby,
  Bank,
  Bone,
  Brain,
  Briefcase,
  Bug,
  Buildings,
  Certificate,
  ChartBar,
  ChartDonut,
  ChartLine,
  ChartLineUp,
  ChatCircleDots,
  CheckCircle,
  Clock,
  Cloud,
  CloudArrowUp,
  Code,
  CoinVertical,
  CompassTool,
  Cpu,
  Cube,
  Database,
  DeviceMobile,
  Envelope,
  Eye,
  Factory,
  FileCheck: CheckCircle,
  FilmStrip,
  Gear,
  GitBranch,
  Globe,
  GlobeHemisphereEast,
  GraduationCap,
  Handshake,
  Headset,
  Heart,
  HeartHalf,
  Lightbulb,
  Lightning,
  Lock,
  LockKey,
  Laptop,
  MagnifyingGlass,
  Medal,
  MegaphoneSimple,
  Monitor,
  Network,
  Package,
  PaintBrush,
  PaperPlaneTilt,
  PathBold: Path,
  Phone,
  Receipt,
  Robot,
  Rocket,
  Scales,
  Server: HardDrives,
  HardDrives,
  ShieldCheck,
  ShieldStar,
  ShoppingBag,
  Stethoscope,
  Star,
  Target,
  TrendUp,
  Trophy,
  Truck,
  UserCheck,
  UserCircle,
  Users,
  UsersFour,
  UsersThree,
  Vector: VectorThree,
  Warning,
  Wrench,
  XCircle,
  FacebookLogo,
  GoogleLogo,
  LinkedinLogo,
};

export default function PhosphorIcon({ name, ...props }) {
  const Component = ICON_MAP[name] || Cube;
  return <Component {...props} />;
}
